@switch (openPage) {
    @case (Pages.ERROR) {
        <auth-error [error]="error"/>
    }
    @case (Pages.RETRY) {
        <div>
            <auth-liveness-retry
                [retryIconName]="retryIconName"
                [retryStatus]="retryStatus"
                [buttonType]="buttonType"
                (retry)="retry()"/>
        </div>
    }
    @case (Pages.LIVENESS) {
        <auth-liveness (livenessResponseEvent)="handleLivenessStatus($event)"/>
    }
}
